<template>
  <div class="modal-overlay" @click="handleOverlayClick">
    <div class="modal-content">
      <div class="modal-header">
        <h3>{{ documentName }}</h3>
        <span class="close" @click="onClose">&times;</span>
      </div>
      <div class="modal-body">
        <div v-if="$slots.sidebar" class="modal-sidebar">
          <slot name="sidebar"></slot>
        </div>
        <div class="modal-main">
          <PdfViewerNutrient :docId="docId" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import PdfViewerNutrient from "@/components/PdfViewerNutrient.vue";

const props = defineProps<{
  documentId: number;
  documentName: string;
  onClose: () => void;
}>();

const docId = ref(props.documentId); // server is expecting docId

const handleOverlayClick = (event: MouseEvent) => {
  const target = event.target as HTMLElement;
  if (target.classList.contains("modal-overlay")) {
    props.onClose();
  }
};

onMounted(() => {
  document.body.style.overflow = "hidden";
});

onUnmounted(() => {
  document.body.style.overflow = "";
});
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000000; /* stupid navbar... */
  cursor: default;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.modal-content {
  position: relative;
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 90vw;
  height: 90vh;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-body {
  display: flex;
  flex-direction: row;
  gap: 20px;
  height: 100%;
  overflow: hidden;
}

.modal-sidebar {
  width: 25%;
  padding: 0 5px;
  max-height: 90%;
  overflow-y: auto;
}

.modal-main {
  flex: 1;
  overflow-y: hidden;
}

.close {
  font-size: 32px;
  cursor: pointer;
  transition: color 0.3s;
}

.close:hover {
  color: #888;
}

::v-deep(.e-pv-notification-popup-content) {
  text-wrap: wrap;
}

::v-deep(.e-pdfviewer) {
  height: 90%;
}

@media (max-width: 1024px) {
  .modal-content {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }

  .modal-body {
    flex-direction: column;
    overflow-y: auto;
  }

  .modal-sidebar {
    max-height: 40%;
    width: 100%;
    border-right: none;
    padding-right: 0;
  }
}
</style>
